import { render, staticRenderFns } from "./VoiceDisputeEditHistoryModal.vue?vue&type=template&id=c9123cf4"
import script from "./VoiceDisputeEditHistoryModal.vue?vue&type=script&lang=js"
export * from "./VoiceDisputeEditHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceDisputeEditHistoryModal.vue?vue&type=style&index=0&id=c9123cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports